import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "../ui/select";
type codingLanguageValue = "javascript" | "java" | "python" | "csharp" | "ruby" | "php";
interface SelectCodingLanguageProps {
	codingLanguage: string;
	setCodingLanguage: React.Dispatch<React.SetStateAction<codingLanguageValue>>; // Function that accepts a string and returns void
}
const SelectCodingLanguage: React.FC<SelectCodingLanguageProps> = ({
	codingLanguage,
	setCodingLanguage,
}) => {
	return (
		<div>
			<Select
				value={codingLanguage}
				onValueChange={(v: codingLanguageValue) => {
					setCodingLanguage(v);
				}}
				disabled
			>
				<label>Language</label>
				<SelectTrigger className="w-full">
					<SelectValue placeholder="JavaScript" />
				</SelectTrigger>
				<SelectContent>
					<SelectItem value="javascript">JavaScript</SelectItem>
					<SelectItem value="java">Java</SelectItem>
					<SelectItem value="python">Python</SelectItem>
					<SelectItem value="ruby">Ruby</SelectItem>
					<SelectItem value="csharp">.Net</SelectItem>
					<SelectItem value=".Net">.Net</SelectItem>
					<SelectItem value="php">php</SelectItem>
				</SelectContent>
			</Select>
		</div>
	);
};

export default SelectCodingLanguage;
